<template>
  <div class="layout-breadcrumb">
    <ul>
      <li v-for="(crumb, index) in breadcrumbs" :key="index">
        <router-link v-if="crumb.to" :to="crumb.to">{{
          crumb.text
        }}</router-link>
        <span v-else>{{ crumb.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    breadcrumbs() {
      const matched = this.$route.matched.filter(
        route => route.meta && route.meta.breadcrumb
      )
      const crumbs = []

      matched.forEach(match => {
        match.meta.breadcrumb.forEach(crumb => {
          // Avoid duplicate 'Dashboard'
          if (
            crumb.text === 'Dashboard' &&
            crumbs.some(c => c.text === 'Dashboard')
          ) {
            return
          }

          // Khusus untuk receiving-detail, ubah breadcrumb berdasarkan query
          if (
            this.$route.name === 'receiving-detail' &&
            crumb.text === 'Penerimaan Barang'
          ) {
            const from = this.$route.query.from
            const dynamicText =
              from === 'laporan barang'
                ? 'Laporan Barang'
                : from === 'warehouse'
                ? 'Transaksi Masuk'
                : 'Penerimaan Barang'

            crumbs.push({ ...crumb, text: dynamicText })
          } else {
            crumbs.push(crumb)
          }
        })
      })

      // Tambahkan Dashboard kalau belum ada
      if (!crumbs.length || crumbs[0].text !== 'Dashboard') {
        if (this.$route.name !== 'dashboard') {
          crumbs.unshift({ text: 'Dashboard', to: { name: 'dashboard' } })
        }
      }

      return crumbs
    }
  }
}
</script>

<style scoped>
.layout-breadcrumb {
  padding: 1em;
  background-color: #f5f5f5; /* Example background color */
  border-bottom: 1px solid #e0e0e0; /* Example border */
}

.layout-breadcrumb ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.layout-breadcrumb li {
  display: flex;
  align-items: center;
}

.layout-breadcrumb li:not(:last-child)::after {
  content: '/';
  margin: 0 0.5em;
  color: #777;
}

.layout-breadcrumb a {
  text-decoration: none;
  color: #333;
}

.layout-breadcrumb a:hover {
  text-decoration: underline;
}

.layout-breadcrumb span {
  color: #555;
}
</style>
